"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conditionalFunctions = void 0;
exports.conditionalFunctions = {
    isEven: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal % 2 === 0)
            return returnVal;
        return elseVal;
    },
    isEqual: function (originalVal, testVal, returnVal, sameType, elseVal) {
        if (returnVal === void 0) { returnVal = originalVal; }
        if (sameType === void 0) { sameType = true; }
        if (elseVal === void 0) { elseVal = ""; }
        if (sameType) {
            if (originalVal === testVal)
                return returnVal;
        }
        else if (originalVal == testVal)
            return returnVal;
        return elseVal;
    },
    isFalse: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (!testVal)
            return returnVal;
        return elseVal;
    },
    isGT: function (originalVal, testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = originalVal; }
        if (elseVal === void 0) { elseVal = ''; }
        if (originalVal > testVal)
            return returnVal;
        return elseVal;
    },
    isGTE: function (originalVal, testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = originalVal; }
        if (elseVal === void 0) { elseVal = ''; }
        if (originalVal >= testVal)
            return returnVal;
        return elseVal;
    },
    isLT: function (originalVal, testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = originalVal; }
        if (elseVal === void 0) { elseVal = ''; }
        if (originalVal < testVal)
            return returnVal;
        return elseVal;
    },
    isLTE: function (originalVal, testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = originalVal; }
        if (elseVal === void 0) { elseVal = ''; }
        if (originalVal <= testVal)
            return returnVal;
        return elseVal;
    },
    isNotEqual: function (originalVal, testVal, returnVal, sameType, elseVal) {
        if (returnVal === void 0) { returnVal = originalVal; }
        if (sameType === void 0) { sameType = true; }
        if (elseVal === void 0) { elseVal = ""; }
        if (sameType) {
            if (originalVal !== testVal)
                return returnVal;
        }
        else if (originalVal != testVal)
            return returnVal;
        return elseVal;
    },
    isNotNull: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal !== null)
            return returnVal;
        return elseVal;
    },
    isNotUndefined: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal !== undefined)
            return returnVal;
        return elseVal;
    },
    isNull: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal === null)
            return returnVal;
        return elseVal;
    },
    isOdd: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal % 2 !== 0)
            return returnVal;
        return elseVal;
    },
    isTrue: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal)
            return returnVal;
        return elseVal;
    },
    isUndefined: function (testVal, returnVal, elseVal) {
        if (returnVal === void 0) { returnVal = testVal; }
        if (elseVal === void 0) { elseVal = ""; }
        if (testVal === undefined)
            return returnVal;
        return elseVal;
    },
};
//# sourceMappingURL=conditionals.js.map